export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14844.2eb83537.jpg";